import api from './api';

export interface SystemVersion {
  name: string;
  version: string;
  buildTime: string;
}

/**
 * Fetches the running backend build's version info from /api/version.
 * Public endpoint — no authentication required.
 */
export const getSystemVersion = async (): Promise<SystemVersion> => {
  const { data } = await api.get<SystemVersion>('/version');
  return data;
};
